"use client";

const _excluded = ["size"];
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
import React from "react";
import BaseIcon from "../../utils/BaseIcon";
const HyperlinkSystemIcon = props => {
  const {
      size = 24
    } = props,
    otherProps = _objectWithoutProperties(props, _excluded);
  const iconFill = "currentColor";
  return /*#__PURE__*/React.createElement(BaseIcon, _extends({
    size: size
  }, otherProps, {
    "data-mesh-component": "HYPERLINK-SYSTEM-ICON"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: iconFill,
    fillRule: "nonzero",
    d: "M2.97 10.595a6.672 6.672 0 0 1 8.854-3.187 6.653 6.653 0 0 1 3.677 4.673.75.75 0 1 1-1.469.303 5.151 5.151 0 0 0-2.845-3.618 5.17 5.17 0 0 0-6.86 2.47L2.532 15.05A5.171 5.171 0 0 0 5 21.91a5.172 5.172 0 0 0 6.862-2.472.75.75 0 1 1 1.355.643 6.673 6.673 0 0 1-8.856 3.186 6.673 6.673 0 0 1-3.187-8.854Zm7.84-6.6A6.673 6.673 0 0 1 19.668.807a6.673 6.673 0 0 1 3.187 8.853l-1.797 3.818a6.673 6.673 0 0 1-8.854 3.187 6.64 6.64 0 0 1-3.445-3.836.75.75 0 1 1 1.417-.49 5.138 5.138 0 0 0 2.665 2.968 5.172 5.172 0 0 0 6.861-2.47l1.795-3.814a5.171 5.171 0 0 0-2.468-6.859 5.172 5.172 0 0 0-6.862 2.472.75.75 0 0 1-1.355-.643"
  })));
};
HyperlinkSystemIcon.displayName = "HyperlinkSystemIcon";
HyperlinkSystemIcon.iconName = "Hyperlink";
export default HyperlinkSystemIcon;